import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

export default withStyles(theme => ({
    root: {
        marginRight: 10,
        backgroundColor: theme.status.midnight[100],
        color: theme.status.yellow.dark,
        borderColor: theme.status.yellow.dark,
        borderWidth: 2,
        borderStyle: "solid",
        borderRadius: 20,
        transitionProperty: "border-color, color",
        transitionDuration: "250ms, 250ms",
        transitionTimingFunction: "linear, linear",
        "&:hover": {
            backgroundColor: theme.status.yellow.dark,
            borderColor: theme.status.yellow.dark,
            color: theme.status.midnight[100]
        }
    }
}))(Button);
